export enum STORED_QUERY_PARAMS {
    hallCode = 'hall_code'
}
